"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.wordmarkSvgHTML = exports.brandIconSvgHTML = exports.groupCashoutLedgerRowsByType = exports.getDaysToRefundByState = exports.generateDepositAccountingStatementHTML = exports.MAINTENANCE_CHARGEBACK_TYPES = exports.CASHOUT_STATUSES = void 0;
const date_fns_1 = require("date-fns");
const date_fns_tz_1 = require("date-fns-tz");
const dates_1 = require("./dates");
const numbers_1 = require("./numbers");
const payments_1 = require("./payments");
const regions_1 = require("./regions");
const rentals_1 = require("./rentals");
// normally we should source these values from the database enum, e.g. via Prisma
// however the frontend sometimes needs access to the statuses in a dropdown
exports.CASHOUT_STATUSES = {
    PENDING: 'pending',
    MAINTENANCE_CHARGEBACKS_FINALIZED: 'maintenance_chargebacks_finalized',
    UTILITIES_FINALIZED: 'utilities_finalized',
    ADJUSTMENTS_FINALIZED: 'adjustments_finalized',
    CASHED_OUT: 'cashed_out'
};
exports.MAINTENANCE_CHARGEBACK_TYPES = {
    DISPOSITION: 'disposition',
    TURN: 'turn'
};
// Function to generate the raw HTML for a tenant's deposit accounting statement
// Does nothing but formatting - inputs should be fetched by the caller
const generateDepositAccountingStatementHTML = (data) => {
    const { fullAddress, state, tenantNames, leaseStartDate, leaseEndDate, noticeGivenDate, moveOutDate, rentalProgramType, isRefunded, walletOrDepositValue, totalRefund, totalBalanceOwed, cashoutLedgerRows, cashoutPendingLiabilities, walletFeeAmount } = data;
    const walletFee = rentalProgramType === rentals_1.RENTAL_PROGRAM_TYPES.UPANDUP
        ? // default to 10% of wallet for Up&Up leases
            walletFeeAmount !== null && walletFeeAmount !== void 0 ? walletFeeAmount : 0.1 * walletOrDepositValue
        : // and no fee for vanilla leases
            0;
    const { totalDeductionsAmount, unpaidRentAmount, acceleratedRents, unpaidLateFeesAmount, unpaidUtilitiesAmount, maintenanceChargebacksAmount, evictionChargebacksAmount, terminationFeesAmount, damages, otherAmount } = (0, exports.groupCashoutLedgerRowsByType)(cashoutLedgerRows, cashoutPendingLiabilities, walletFee);
    const isUpAndUp = rentalProgramType === rentals_1.RENTAL_PROGRAM_TYPES.UPANDUP;
    const walletOrDepositText = isUpAndUp ? 'Up&Up Wallet' : 'Security Deposit';
    const totalDeductionsFormatted = (0, numbers_1.formatMoney)(totalDeductionsAmount, 2, '$');
    const walletOrDepositValueFormatted = (0, numbers_1.formatMoney)(walletOrDepositValue, 2, '$');
    const totalRefundFormatted = (0, numbers_1.formatMoney)(Math.abs(totalRefund), 2, '$');
    const totalBalanceFormatted = (0, numbers_1.formatMoney)(Math.abs(totalBalanceOwed), 2, '$');
    const daysToRefund = isUpAndUp ? 60 : (0, exports.getDaysToRefundByState)(state);
    const currentDate = (0, date_fns_1.format)(new Date(), 'MMMM d, yyyy');
    const unpaidRentFormatted = unpaidRentAmount ? (0, numbers_1.formatMoney)(unpaidRentAmount, 2, '$') : undefined;
    const unpaidLateFeesFormatted = unpaidLateFeesAmount
        ? (0, numbers_1.formatMoney)(unpaidLateFeesAmount, 2, '$')
        : undefined;
    const unpaidUtilitiesFormatted = unpaidUtilitiesAmount
        ? (0, numbers_1.formatMoney)(unpaidUtilitiesAmount, 2, '$')
        : undefined;
    const maintenanceChargebacksFormatted = maintenanceChargebacksAmount
        ? (0, numbers_1.formatMoney)(maintenanceChargebacksAmount, 2, '$')
        : undefined;
    const evictionChargebacksFormatted = evictionChargebacksAmount
        ? (0, numbers_1.formatMoney)(evictionChargebacksAmount, 2, '$')
        : undefined;
    const terminationFeesFormatted = terminationFeesAmount
        ? (0, numbers_1.formatMoney)(terminationFeesAmount, 2, '$')
        : undefined;
    const walletFeeFormatted = walletFeeAmount ? (0, numbers_1.formatMoney)(walletFeeAmount, 2, '$') : undefined;
    const otherFormatted = otherAmount ? (0, numbers_1.formatMoney)(otherAmount, 2, '$') : undefined;
    // Generate table rows for deductions
    const deductionRows = [];
    if (unpaidRentFormatted) {
        deductionRows.push(`
      <tr>
        <td style="width: 70%; border: 1px solid black; padding: 8px;">Rent Remaining Unpaid</td>
        <td style="width: 30%; border: 1px solid black; padding: 8px; text-align: right;">${unpaidRentFormatted}</td>
      </tr>
    `);
    }
    if (acceleratedRents) {
        acceleratedRents.forEach((accRent) => {
            deductionRows.push(`
        <tr>
          <td style="border: 1px solid black; padding: 8px;">Accelerated Rent (${accRent.description})</td>
          <td style="border: 1px solid black; padding: 8px; text-align: right;">${(0, numbers_1.formatMoney)(accRent.amount, 2, '$')}</td>
        </tr>
      `);
        });
    }
    if (unpaidLateFeesFormatted) {
        deductionRows.push(`
      <tr>
        <td style="border: 1px solid black; padding: 8px;">Unpaid Late Fees</td>
        <td style="border: 1px solid black; padding: 8px; text-align: right;">${unpaidLateFeesFormatted}</td>
      </tr>
    `);
    }
    if (unpaidUtilitiesFormatted) {
        deductionRows.push(`
      <tr>
        <td style="border: 1px solid black; padding: 8px;">Unpaid Utilities</td>
        <td style="border: 1px solid black; padding: 8px; text-align: right;">${unpaidUtilitiesFormatted}</td>
      </tr>
    `);
    }
    if (evictionChargebacksFormatted) {
        deductionRows.push(`
      <tr>
        <td style="border: 1px solid black; padding: 8px;">Attorney Fees</td>
        <td style="border: 1px solid black; padding: 8px; text-align: right;">${evictionChargebacksFormatted}</td>
      </tr>
    `);
    }
    if (terminationFeesFormatted) {
        deductionRows.push(`
      <tr>
        <td style="border: 1px solid black; padding: 8px;">Termination Fees</td>
        <td style="border: 1px solid black; padding: 8px; text-align: right;">${terminationFeesFormatted}</td>
      </tr>
    `);
    }
    if (maintenanceChargebacksFormatted) {
        deductionRows.push(`
      <tr>
        <td style="border: 1px solid black; padding: 8px;">Damages (General)</td>
        <td style="border: 1px solid black; padding: 8px; text-align: right;">${maintenanceChargebacksFormatted}</td>
      </tr>
    `);
    }
    if (damages) {
        damages.forEach((damage) => {
            deductionRows.push(`
        <tr>
          <td style="border: 1px solid black; padding: 8px;">${damage.description}</td>
          <td style="border: 1px solid black; padding: 8px; text-align: right;">${(0, numbers_1.formatMoney)(damage.amount, 2, '$')}</td>
        </tr>
      `);
        });
    }
    if (walletFeeFormatted) {
        deductionRows.push(`
      <tr>
        <td style="border: 1px solid black; padding: 8px;">Up&Up Wallet Fee</td>
        <td style="border: 1px solid black; padding: 8px; text-align: right;">${walletFeeFormatted}</td>
      </tr>
    `);
    }
    if (otherFormatted) {
        deductionRows.push(`
      <tr>
        <td style="border: 1px solid black; padding: 8px;">Other</td>
        <td style="border: 1px solid black; padding: 8px; text-align: right;">${otherFormatted}</td>
      </tr>
    `);
    }
    return `
    <!DOCTYPE html>
    <html>
    <head>
      <meta charset="UTF-8">
      <title>Deposit Accounting Statement</title>
    </head>
    <body style="margin: 0; padding: 0; font-family: Arial, sans-serif;">
      <div style="line-height: 1.15; width: 816px; background-color: white; padding: 80px 80px 8px 80px; font-size: 12px; line-height: 16px;">
        <div style="margin-bottom: 8px;">
          <div style="margin-bottom: 4px; color:#9CE5E5">${(0, exports.brandIconSvgHTML)()}${(0, exports.wordmarkSvgHTML)()}</div>
          <div style="margin-bottom: 4px;">169 Madison Avenue, Suite 2485</div>
          <div style="margin-bottom: 4px;">New York, NY 10016</div>
          <div style="margin-bottom: 4px; font-size: 14px; font-weight: bold;">Deposit Accounting Statement</div>
        </div>
        <div style="margin-bottom: 16px;">
          <div>${tenantNames}</div>
          <div>${currentDate}</div>
        </div>
        <div style="margin-bottom: 8px;">
          <p>
            Below is an accounting of the ${walletOrDepositText} for <strong>${fullAddress}</strong> (the "Leased Premises").
          </p>
        </div>
        <div style="margin-bottom: 16px;">
          <div>Lease Start Date: ${leaseStartDate ? (0, date_fns_tz_1.formatInTimeZone)(leaseStartDate, dates_1.TIME_ZONES.UTC, 'MM/dd/yyyy') : ''}</div>
          <div>Lease End Date: ${leaseEndDate ? (0, date_fns_tz_1.formatInTimeZone)(leaseEndDate, dates_1.TIME_ZONES.UTC, 'MM/dd/yyyy') : ''}</div>
          <div>Notice Given/Received: ${noticeGivenDate ? (0, date_fns_tz_1.formatInTimeZone)(noticeGivenDate, dates_1.TIME_ZONES.UTC, 'MM/dd/yyyy') : ''}</div>
          <div>Move-out Date: ${moveOutDate ? (0, date_fns_tz_1.formatInTimeZone)(moveOutDate, dates_1.TIME_ZONES.UTC, 'MM/dd/yyyy') : ''}</div>
        </div>
        <div style="margin-bottom: 8px;">
          <div style="margin-bottom: 8px; font-weight: bold; text-decoration: underline;">${walletOrDepositText}:</div>
          <div>Total ${walletOrDepositText}: ${walletOrDepositValueFormatted}</div>
        </div>
        <div style="margin-bottom: 12px;">
          <div style="margin-bottom: 8px; font-weight: bold; text-decoration: underline;">Deductions:</div>
          <p>
            This is notice that the owner of the Leased Premises intends to impose a claim against
            your ${walletOrDepositText} for the following items:
          </p>
        </div>
        <table style="margin-bottom: 16px; width: 100%; border-collapse: collapse; border: 1px solid black;">
          <tbody>
            ${deductionRows.join('')}
            <tr style="font-weight: bold;">
              <td style="border: 1px solid black; padding: 8px;">Total Deductions</td>
              <td style="border: 1px solid black; padding: 8px; text-align: right;">${totalDeductionsFormatted}</td>
            </tr>
          </tbody>
        </table>
        <div style="margin-bottom: 8px;">
          <div style="margin-bottom: 8px; font-weight: bold; text-decoration: underline;">Resulting Balance</div>
          ${isRefunded
        ? `
            <p>
              A Refund in the amount of <span style="text-decoration: underline;">${totalRefundFormatted}</span> will
              be paid within ${daysToRefund} days of your move-out
              ${isUpAndUp ? " (pending Up&Up's receipt of your signed W-9 form)" : ''}.
            </p>
          `
        : `
            <p>
              The Balance Due to Landlord of <span style="text-decoration: underline;">${totalBalanceFormatted}</span> must be paid upon receipt of
              this statement. Payment can be made through your Buildium Resident Portal. If payment is
              not received within <strong>30 days</strong> of the date of this letter, the outstanding
              balance will be referred to a collections agency for further action.
            </p>
          `}
        </div>
        <div style="margin-bottom: 16px;">
          <p>
            If you should have any questions, please feel free to contact us at 855-908-0600 or
            <a href="mailto:success@upandup.co" style="color: #3b82f6; text-decoration: underline;">success@upandup.co</a>.
          </p>
        </div>
        <div style="margin-top: 8px;">
          <div>Sincerely,</div>
          <div>The Up&Up Team</div>
        </div>
      </div>
    </body>
    </html>
  `;
};
exports.generateDepositAccountingStatementHTML = generateDepositAccountingStatementHTML;
const getDaysToRefundByState = (state) => {
    switch (state) {
        case regions_1.STATES.IN:
        case regions_1.STATES_FULL.IN:
            return 45;
        default:
            return 30;
    }
};
exports.getDaysToRefundByState = getDaysToRefundByState;
const groupCashoutLedgerRowsByType = (ledgerItems, pendingLiabilities, walletFeeAmount) => {
    const totalPendingLiabilitiesAmount = pendingLiabilities.reduce((acc, item) => acc + item.amount, 0);
    let totalDeductionsAmount = totalPendingLiabilitiesAmount + walletFeeAmount;
    let unpaidRentAmount = 0;
    const acceleratedRents = [];
    let unpaidLateFeesAmount = 0;
    let unpaidUtilitiesAmount = 0;
    let maintenanceChargebacksAmount = 0;
    let evictionChargebacksAmount = 0;
    let terminationFeesAmount = 0;
    let otherAmount = 0;
    ledgerItems.forEach((item) => {
        var _a;
        let sign = 1;
        if (item.type !== 'liability') {
            sign = -1;
        }
        const signedAmount = item.amount_remaining * sign;
        totalDeductionsAmount += signedAmount;
        const liabilityType = item.liability_type.name;
        const category = item.liability_type.category;
        if (liabilityType === 'Rent') {
            unpaidRentAmount += signedAmount;
        }
        else if (liabilityType === 'Accelerated Rent') {
            acceleratedRents.push({
                amount: signedAmount,
                description: (_a = item.note) !== null && _a !== void 0 ? _a : ''
            });
        }
        else if (liabilityType === 'Late Fee') {
            unpaidLateFeesAmount += signedAmount;
        }
        else if (category === payments_1.PAYMENT_CATEGORIES.UTILITIES) {
            unpaidUtilitiesAmount += signedAmount;
        }
        else if (category === payments_1.PAYMENT_CATEGORIES.MAINTENANCE_CHARGEBACK) {
            maintenanceChargebacksAmount += signedAmount;
        }
        else if (liabilityType === 'Tenant Eviction Chargeback') {
            evictionChargebacksAmount += signedAmount;
        }
        else if (liabilityType === 'Tenant Termination Fee') {
            terminationFeesAmount += signedAmount;
        }
        else {
            otherAmount += signedAmount;
        }
    });
    const damages = pendingLiabilities.map((liability) => {
        var _a, _b, _c;
        const name = (_b = (_a = liability.ledger_account) === null || _a === void 0 ? void 0 : _a.name) !== null && _b !== void 0 ? _b : '';
        // Not ideal, but do some regex to find the category of damage
        const description = (_c = name.match(/- (.+)/)) === null || _c === void 0 ? void 0 : _c[1];
        return {
            amount: liability.amount,
            description: description ? `Damages (${description})` : 'Damages'
        };
    });
    return {
        totalDeductionsAmount,
        unpaidRentAmount,
        acceleratedRents,
        unpaidLateFeesAmount,
        unpaidUtilitiesAmount,
        evictionChargebacksAmount,
        terminationFeesAmount,
        maintenanceChargebacksAmount,
        damages,
        otherAmount
    };
};
exports.groupCashoutLedgerRowsByType = groupCashoutLedgerRowsByType;
const brandIconSvgHTML = () => `
<svg width="27" height="32" viewBox="0 0 27 32" fill="none" xmlns="http://www.w3.org/2000/svg" style="display:inline-block; vertical-align:middle">
  <path d="M16.2473 0.849886L24.2391 6.05526C25.7332 7.02849 26.6253 8.67406 26.6253 10.4575V15.0634H22.6972V10.4575C22.6972 10.0075 22.4721 9.5923 22.0953 9.34685L14.1033 4.14148C13.6668 3.85726 13.1017 3.85546 12.6636 4.13674L4.5373 9.35586C4.15589 9.60082 3.92811 10.0179 3.92811 10.4711V15.0634H0V10.4711C0 8.67428 0.902615 7.02173 2.41449 6.05075L10.541 0.831631C12.2776 -0.283822 14.5175 -0.276611 16.2473 0.849886Z" fill="currentColor"/>
  <path d="M13.3126 28.072C8.13798 28.072 3.92811 23.8619 3.92811 18.6872H0C0 26.0281 5.97203 32 13.3126 32C20.6533 32 26.6253 26.0281 26.6253 18.6872H22.6972C22.6972 23.8619 18.4873 28.072 13.3126 28.072Z" fill="currentColor"/>
  <path d="M19.0667 18.6925H15.1388C15.1388 19.6993 14.3194 20.5186 13.3126 20.5186C12.3058 20.5186 11.4866 19.6993 11.4866 18.6925H7.55855C7.55855 21.8654 10.1399 24.4466 13.3126 24.4466C16.4856 24.4466 19.0667 21.8654 19.0667 18.6925Z" fill="currentColor"/>
</svg>
`;
exports.brandIconSvgHTML = brandIconSvgHTML;
const wordmarkSvgHTML = (opts = {}) => {
    const { color = '#000000', width = 66, height = 22 } = opts;
    return `
<svg width="${width}" height="${height}" viewBox="0 0 66 22" fill="none" xmlns="http://www.w3.org/2000/svg" style="display:inline-block; vertical-align:middle; color:${color}">
  <path fill-rule="evenodd" clip-rule="evenodd" d="M30.6162 17.6757C32.452 17.6757 33.9303 16.7697 35.2414 15.363L37.1489 17.3657H40.8441L37.0296 13.3843L39.3421 10.8332V7.25693L35.3129 11.5961L32.4998 8.66358L33.2388 8.11526C34.4307 7.2093 35.6228 5.96948 35.6228 4.30067C35.6228 1.77338 33.6441 0.10437 30.9978 0.10437C28.8041 0.10437 26.4677 1.63026 26.4677 4.4199C26.4677 5.99342 27.5883 7.30464 28.399 8.13903L28.685 8.44904L28.518 8.56824C26.7539 9.87945 25.5855 11.0716 25.5855 13.2412C25.5855 15.4586 27.3498 17.6757 30.6162 17.6757ZM30.7832 6.89939L30.3063 6.37482C29.7101 5.73115 29.1856 5.06344 29.1856 4.25289C29.1856 3.03714 30.1393 2.44098 31.0214 2.44098C32.1182 2.44098 32.905 3.25148 32.905 4.25289C32.905 4.89658 32.6429 5.51649 31.7607 6.18412L30.7832 6.89939ZM33.501 13.5511L33.4773 13.575C32.6188 14.5048 31.7844 15.1724 30.6637 15.1724C29.2812 15.1724 28.4227 14.0996 28.4227 13.0503C28.4227 11.9538 28.995 11.2622 29.8057 10.6664L30.3777 10.2372L33.501 13.5511Z" fill="currentColor"/>
  <path fill-rule="evenodd" clip-rule="evenodd" d="M12.857 21.8955V5.75495H15.5272V7.32846C16.0995 6.32714 17.4347 5.49268 19.2229 5.49268C22.656 5.49268 24.587 8.11529 24.587 11.5483C24.587 15.0294 22.4651 17.6519 19.1273 17.6519C17.4586 17.6519 16.1948 16.9366 15.5989 16.0546V21.8955H12.857ZM18.6984 7.94846C16.8863 7.94846 15.575 9.3789 15.575 11.5483C15.575 13.7657 16.8863 15.1962 18.6984 15.1962C20.534 15.1962 21.8214 13.7657 21.8214 11.5483C21.8214 9.3789 20.5579 7.94846 18.6984 7.94846Z" fill="currentColor"/>
  <path d="M4.77995 17.6996C2.01442 17.6996 0.393188 15.6492 0.393188 13.0743V5.7549H3.15872V12.5736C3.15872 14.0041 3.82632 15.2201 5.49511 15.2201C7.09244 15.2201 7.92706 14.1471 7.92706 12.6214V5.7549H10.6926V15.2439C10.6926 16.1977 10.764 16.9365 10.8118 17.3657H8.16552C8.11774 17.1036 8.07018 16.5551 8.07018 16.0784C7.49792 17.1274 6.13882 17.6996 4.77995 17.6996Z" fill="currentColor"/>
  <path d="M45.4831 17.6996C42.7178 17.6996 41.0966 15.6492 41.0966 13.0743V5.7549H43.8621V12.5736C43.8621 14.0041 44.5295 15.2201 46.1985 15.2201C47.7958 15.2201 48.6302 14.1471 48.6302 12.6214V5.7549H51.396V15.2439C51.396 16.1977 51.4674 16.9365 51.5152 17.3657H48.8689C48.8211 17.1036 48.7733 16.5551 48.7733 16.0784C48.2011 17.1274 46.8422 17.6996 45.4831 17.6996Z" fill="currentColor"/>
  <path fill-rule="evenodd" clip-rule="evenodd" d="M53.5604 5.75495V21.8955H56.3023V16.0546C56.8982 16.9366 58.1619 17.6519 59.831 17.6519C63.1685 17.6519 65.2906 15.0294 65.2906 11.5483C65.2906 8.11529 63.3594 5.49268 59.9261 5.49268C58.1381 5.49268 56.8028 6.32714 56.2308 7.32846V5.75495H53.5604ZM56.2784 11.5483C56.2784 9.3789 57.5897 7.94846 59.4016 7.94846C61.2613 7.94846 62.525 9.3789 62.525 11.5483C62.525 13.7657 61.2376 15.1962 59.4016 15.1962C57.5897 15.1962 56.2784 13.7657 56.2784 11.5483Z" fill="currentColor"/>
</svg>
  `;
};
exports.wordmarkSvgHTML = wordmarkSvgHTML;
